import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { urls } from '@/constants/urls';
import { useCurrentOrganisation } from '@/hooks/use-current-organisation';
import { useUserRole } from '@/hooks/use-user-role';

export const HomePage: FC = () => {
  const navigate = useNavigate();
  const { isPlatformAdmin } = useUserRole();
  const { isUsingOrganisationOverride, organisation } =
    useCurrentOrganisation();

  // Note: There's no UI on the homepage so we're redirecting to the organisation page for platform admin users and to the groups page for organisation level users
  useEffect(() => {
    let to = isPlatformAdmin ? urls.organisations.base : urls.groups.base;
    if (isUsingOrganisationOverride && organisation) {
      to = urls.organisations.organisation.groups.base.compose(organisation.id);
    }

    navigate(to, { replace: true });
  }, [isPlatformAdmin, isUsingOrganisationOverride, organisation, navigate]);

  return null;
};
